var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SearchBar',{attrs:{"placeholder":_vm.$t('modules.evaluations.topbar.searchLabel'),"hasResults":_vm.hasResults},on:{"queryChange":_vm.setQuery}})}
var staticRenderFns = []

export { render, staticRenderFns }